var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon__item",class:{
  ['wg-bg-color__' + _vm.realColor]: !_vm.isCustom(_vm.realColor) ? _vm.realColor : '',
},style:({
  width: _vm.realWidth + 'px', 
  height: _vm.realWidth + 'px', 
  ['background-color']: _vm.realOrigin ? 'rgba(0, 0, 0, 0)' : _vm.iconColor,
  ['background-image']: _vm.realOrigin ? 'url(' + _vm.icon + ')' : _vm.defaultIcon, 
  ['-webkit-mask-image']:  _vm.realOrigin ? _vm.defaultIcon : 'url(' + _vm.icon + ')', 
  ['mask-image']: _vm.realOrigin ? _vm.defaultIcon : 'url(' + _vm.icon + ')',
})})
}
var staticRenderFns = []

export { render, staticRenderFns }